export default "__VITE_ASSET__ClOimo8P__"